import React, { useState } from 'react'
import { Box, Button, Dialog, DialogContent, DialogTitle, Typography } from '@mui/material'
import { AdvancedCareTeamMember, AdvancedTrackDefinition, AdvancedTrackLead } from '../../api/types'
import LeadPicker from './LeadPicker'
import { findTrack, trackTitle } from './trackTransitions'
import { useLeadDirectory } from './useLeadDirectory'

export type LeadTarget = { trackKey: string; lead: AdvancedTrackLead; note?: string }

type Props = {
  target: LeadTarget | null
  catalog: AdvancedTrackDefinition[]
  careTeam: AdvancedCareTeamMember[]
  onCancel: () => void
  onConfirm: (lead: AdvancedTrackLead) => void
}

type FormProps = Omit<Props, 'target'> & { target: LeadTarget }

const ChangeLeadForm = ({ target, catalog, careTeam, onCancel, onConfirm }: FormProps) => {
  const directory = useLeadDirectory(careTeam)
  const [lead, setLead] = useState<AdvancedTrackLead>(target.lead)

  return (
    <Dialog open onClose={onCancel} maxWidth="xs" fullWidth>
      <DialogTitle>Who leads {trackTitle(catalog, target.trackKey)}?</DialogTitle>
      <DialogContent>
        {target.note && (
          <Typography variant="body2" sx={{ mb: 1 }}>
            {target.note}
          </Typography>
        )}
        <Box sx={{ pt: 1 }}>
          <LeadPicker
            options={directory.optionsFor(findTrack(catalog, target.trackKey))}
            value={lead}
            onChange={setLead}
          />
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, mt: 2 }}>
          <Button onClick={onCancel}>Cancel</Button>
          <Button variant="contained" onClick={() => onConfirm(lead)}>
            Save
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  )
}

const ChangeLeadDialog = ({ target, ...rest }: Props) => (target ? <ChangeLeadForm target={target} {...rest} /> : null)

export default ChangeLeadDialog
